angular.module('rjmNg.common.api')
.constant('CONNECTION_CHECKS',
  STATUS: Object.freeze
    PENDING: "PENDING"
    OK: "OK"
    FAILED: "FAILED"

  FAIL_REASON: Object.freeze
    CANNOT_CONNECT: 'CANNOT_CONNECT'
    NO_CREATE_SCHEMA_RIGHTS: 'NO_CREATE_SCHEMA_RIGHTS'
    NOT_REDSHIFT_INSTANCE: 'NOT_REDSHIFT_INSTANCE'
    CREDENTIALS_INVALID: 'CREDENTIALS_INVALID'

  FAIL_REASON_MESSAGES: Object.freeze
    CANNOT_CONNECT: 'Unable to connect to your Redshift instance. Please check that your connection information is correct.'
    NO_CREATE_SCHEMA_RIGHTS: 'Unable to create schemas. Please check the permissions you have granted us.'
    NOT_REDSHIFT_INSTANCE: 'Connected database was something other than Redshift. Please provide credentials for a Redshift instance.'
    CREDENTIALS_INVALID: 'An error occurred while authorizing this integration.'
)
